/**
 * Mixin pour calculer l'année contractuelle
 * Une année contractuelle va du 16/01/N au 15/01/N+1
 * Si la date actuelle est entre le 01/01 et le 15/01, l'année contractuelle est N-1
 */
export default {
  computed: {
    /**
     * Calcule l'année contractuelle actuelle
     * @returns {number} L'année contractuelle
     */
    currentYear() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();

      // Si on est entre le 1er janvier et le 15 janvier inclus
      if (month === 1 && day <= 15) {
        return year - 1;
      }
      return year;
    },
    /**
     * Année contractuelle précédente
     * @returns {number} L'année contractuelle précédente
     */
    previousYear() {
      return this.currentYear - 1;
    },
  },
};
